import { memo, useEffect } from 'react'
import { useDisconnect } from 'wagmi'

import { usePusherEvents } from '../../hooks/usePusherEvents'
import { DashboardLayout } from '../../layouts/dashboard'
import { disconnectMetamaskWallet } from '../../util/staking/staking.helpers'
import { SplashScreen } from '../shared/loading-screen'

const AuthorizedLayout = ({ children, loading, initSignOut, ...restProps }) => {
  const { disconnect } = useDisconnect()
  usePusherEvents()
  useEffect(() => {
    if (initSignOut) {
      disconnect()
      disconnectMetamaskWallet()
    }
  }, [initSignOut])

  return loading ? (
    <SplashScreen />
  ) : (
    <DashboardLayout {...restProps}>{children}</DashboardLayout>
  )
}

export default memo(AuthorizedLayout)
